export default "__VITE_ASSET__CmCMqAJi__"